import { NJProgress, NJButton, NJIcon, NJTooltip, NJToastContainer } from '@engie-group/fluid-design-system-react';
import React, { useState, useEffect } from 'react';
import { useOktaAuth } from "@okta/okta-react";
import { useUser } from './context/UserContext';
import './AnalysisPanel.css';
import { Flex } from "antd";
import { invokeLambda, displayNetworkError } from './api';
import { apiGatewayConfig } from './config';
import { useModel } from './context/ModelContext';

function AnalysisPanel({ firstAd, editedAd, updateGenderAnalysis, handleGenderBalance, handleFeedbackButton, language }) {

    const userInfo = useUser();
    const { oktaAuth } = useOktaAuth();
    const [modelProvider] = useModel();

    const [generatedAd, setGeneratedAd] = useState('');
    const [updatedAd, setUpdatedAd] = useState('');
    const [showUpdateButton, setShowUpdateButton] = useState(false);

    const [genderCurrentAd, setGenderCurrentAd] = useState('');
    // const [genderProcessing, setGenderProcessing] = useState(false);
    const [genderValueMale, setGenderValueMale] = useState(0);
    const [genderValueFemale, setGenderValueFemale] = useState(0);
    //const [genderExplanation, setGenderExplanation] = useState('');

    // const [languageProcessing, setLanguageProcessing] = useState(false);
    const [languageValue, setLanguageValue] = useState(0);
    // const [languageExplanation, setLanguageExplanation] = useState('');
    const [languageCurrentAd, setLanguageCurrentAd] = useState('');

    const [complianceValue, setComplianceValue] = useState(0);
    const [complianceExplanation, setComplianceExplanation] = useState(0);
    const [complianceCurrentAd, setComplianceCurrentAd] = useState('');


    useEffect(() => {
        if (firstAd) {
            setShowUpdateButton(editedAd && editedAd !== updatedAd);
        }
    }, [firstAd, editedAd, updatedAd]);

    useEffect(() => {
        setGeneratedAd(firstAd);
        setUpdatedAd(firstAd);
        setShowUpdateButton(false);
    }, [firstAd]);

    const handleRefreshButton = async () => {
        setGeneratedAd(editedAd);
        setUpdatedAd(editedAd);
        setShowUpdateButton(false);
    }

    const handleMoreMan = async () => {
        handleGenderBalance('men');
    }

    const handleMoreWoman = async () => {
        handleGenderBalance('women');
    }

    const handleEquality = async () => {
        handleGenderBalance('equality');
    }


    useEffect(() => {

        const handleGenderAnalysis = async () => {
            // Prepare request
            const request = {
                job_ad: generatedAd,
                provider: modelProvider.split('/')[0],
                model: modelProvider.split('/')[1],
            }

            setGenderValueMale(-1);
            setGenderValueFemale(-1);

            // Call Lambda
            try {
                const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointJobAdGenderEvaluator, request, userInfo);
                const statusCode = response.statusCode;
                if (statusCode === 200) {
                    const man = typeof (response.gender_analysis?.final_scores?.total_masculine_score) === 'number' ? parseInt(response.gender_analysis?.final_scores?.total_masculine_score) : 0;
                    const woman = typeof (response.gender_analysis?.final_scores?.total_feminine_score) === 'number' ? parseInt(response.gender_analysis?.final_scores?.total_feminine_score) : 0;
                    const analysis = response.gender_analysis;
                    if (man && woman) {
                        setGenderValueMale(man);
                        setGenderValueFemale(woman);
                        updateGenderAnalysis(analysis);
                    }
                } else {
                    console.error("Error:", response.body);
                    alert(response.body);
                }
            } catch (error) {
                console.error('Error invoking Lambda:', error);
                displayNetworkError(error);
            }
        };

        if (generatedAd && generatedAd !== genderCurrentAd) {
            setGenderCurrentAd(generatedAd);
            handleGenderAnalysis();
        }
    }, [updateGenderAnalysis, generatedAd, modelProvider, genderCurrentAd, oktaAuth, userInfo]);

    /* Handle language complexity */
    useEffect(() => {

        const handleLanguageAnalysis = async () => {
            // Prepare request
            const request = {
                job_ad: generatedAd,
                provider: modelProvider.split('/')[0],
                model: modelProvider.split('/')[1],
            }

            // setLanguageProcessing(true);
            setLanguageValue(0);
            // setLanguageExplanation(null);

            // Call Lambda

            try {
                const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointJobAdLanguageComplexity, request, userInfo);
                const statusCode = response.statusCode;
                // setLanguageProcessing(false);
                if (statusCode === 200) {
                    if (response.complexity_analysis?.complexity_level) {
                        setLanguageValue(parseInt(response.complexity_analysis?.complexity_level));
                        // setLanguageExplanation(response.complexity_analysis?.explanation)
                    }
                } else {
                    console.error("Error:", response.body);
                    alert(response.body);
                }
            } catch (error) {
                console.error('Error invoking Lambda:', error);
                displayNetworkError(error);
                // setLanguageProcessing(false);
            }
        };

        if (generatedAd && generatedAd !== languageCurrentAd) {
            setLanguageCurrentAd(generatedAd);
            handleLanguageAnalysis();
        }
    }, [generatedAd, modelProvider, languageCurrentAd, oktaAuth, userInfo]);


    /* Handle guidelines compliance */
    useEffect(() => {

        const handleComplianceAnalysis = async () => {
            // Prepare request
            const request = {
                job_ad: generatedAd,
                provider: modelProvider.split('/')[0],
                model: modelProvider.split('/')[1],
            }

            setComplianceValue(0);
            setComplianceExplanation('');

            // Call Lambda
            try {
                const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointJobAdGuidelinesCompliance, request, userInfo);
                const statusCode = response.statusCode;
                //if (statusCode === 200) {
                    setComplianceValue(parseInt(response.analysis?.rating))
                    setComplianceExplanation(response.analysis?.explanation)
                //} else {
                //    console.error("Error:", response.body);
                //    alert(response.body);
                //}
            } catch (error) {
                displayNetworkError(error);
                console.error('Error invoking Lambda:', error);
            }
        };

        if (generatedAd && generatedAd !== complianceCurrentAd) {
            setComplianceCurrentAd(generatedAd);
            handleComplianceAnalysis();
        }
    }, [generatedAd, modelProvider, complianceCurrentAd, oktaAuth, userInfo]);

    return (
        <div className='analysis-panel-container'>
            <NJToastContainer type="full-width" />
            <Flex justify="space-between" align="center" className='analysis-panel-title-line' >
                <div className='analysis-panel-title'>
                    Job ad analysis
                </div>
                <NJButton
                    className='analysis-update-button'
                    label="Analyze the ad"
                    variant="primary"
                    icon="analytics"
                    iconClassName="material-icons-outlined"
                    emphasis="minimal"
                    size="small"
                    disabled={!showUpdateButton}
                    onClick={(e) => { handleRefreshButton() }}
                />
            </Flex>
            <div className='analysis-panel-scroll'>
                <div className='analysis-panel-gray-box'>
                    <div className='analysis-panel-gray-box-title'>
                        Gender equality in words used
                    </div>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-gauge-line'  >
                        <div className='analysis-panel-gray-box-gauge-label'>
                            Man
                        </div>
                        <NJProgress className='analysis-panel-gray-box-gauge-comp'
                            value={genderValueMale}
                        />
                    </Flex>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-gauge-line'  >
                        <div className='analysis-panel-gray-box-gauge-label'>
                            Woman
                        </div>
                        <NJProgress className='analysis-panel-gray-box-gauge-comp'
                            value={genderValueFemale}
                        />
                    </Flex>
                    <div className='analysis-panel-gray-box-gauge-rework'>
                        Rework the balance
                    </div>
                    <Flex justify='flex-start' align="center" gap={12} >
                        <NJButton
                            label="+ Man"
                            variant="ai" emphasis="minimal" scale="xs"
                            disabled={false}
                            onClick={(e) => { handleMoreMan() }}
                        />
                        <NJButton
                            label="+ Equality"
                            variant="ai" emphasis="bold" scale="xs"
                            disabled={false}
                            onClick={(e) => { handleEquality() }}
                        />
                        <NJButton
                            label="+ Woman"
                            variant="ai" emphasis="minimal" scale="xs"
                            disabled={false}
                            onClick={(e) => { handleMoreWoman() }}
                        />
                    </Flex>
                </div>

                <div className='analysis-panel-gray-box'>
                    <div className='analysis-panel-gray-box-title'>
                        Language complexity
                    </div>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-gauge-line'  >
                        <div className='analysis-panel-gray-box-gauge-label'>
                            Complexity
                        </div>
                        <NJProgress className='analysis-panel-gray-box-gauge-comp'
                            value={languageValue}
                        />
                    </Flex>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-warning' >
                        <Flex justify="space-between" align="center" gap={8}>
                            <NJIcon
                                className='analysis-panel-info-icon'
                                name="warning"
                                variant="information"
                                size="sm"
                            />
                            <div>Warning on language complexity</div>
                        </Flex>
                        <div>

                            <NJTooltip
                                hasArrow
                                placement="left"
                                text={"Language complexity analysis may fail or produce biased results depending on the domain or profession"}
                            >
                                <NJIcon
                                    className='analysis-panel-info-icon'
                                    name="info"
                                    variant="information"
                                    size="sm"
                                />
                            </NJTooltip>

                        </div>
                    </Flex>
                    {/* 
                <div className='analysis-panel-gray-box-gauge-rework'>
                    Rework the balance
                </div>
                <Flex justify='flex-start' align="center" gap={12} >
                    <NJButton
                        label="- complexity"
                        variant="ai" emphasis="minimal" scale="xs"
                        disabled={false}
                        onClick={(e) => { }}
                    />
                    <NJButton
                        label="+ complexity"
                        variant="ai" emphasis="minimal" scale="xs"
                        disabled={false}
                        onClick={(e) => { }}
                    />
                </Flex>
                */}
                </div>

                <div className='analysis-panel-gray-box'>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-title' >
                        <div >
                            Guidelines compliance
                        </div>
                        <div>
                            {complianceExplanation && <>
                                <NJTooltip
                                    hasArrow
                                    placement="left"
                                    text={complianceExplanation}
                                >
                                    <NJIcon
                                        className='analysis-panel-info-icon'
                                        name="info"
                                        variant="information"
                                        size="sm"
                                    />
                                </NJTooltip>
                            </>}
                        </div>
                    </Flex>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-gauge-line'  >
                        <div className='analysis-panel-gray-box-gauge-label'>
                            Compliance
                        </div>
                        <NJProgress className='analysis-panel-gray-box-gauge-comp'
                            value={complianceValue}
                        />
                    </Flex>
                    <Flex justify="space-between" align="center" className='analysis-panel-gray-box-warning' >
                        <Flex justify="space-between" align="center" gap={8}>
                            <NJIcon
                                className='analysis-panel-info-icon'
                                name="warning"
                                variant="information"
                                size="sm"
                            />
                            <div>Warning on guidelines compliance</div>
                        </Flex>
                        <div>

                            <NJTooltip
                                hasArrow
                                placement="left"
                                text={"Guidelines compliance analysis may be inaccurate or biased depending on domain-specific factors"}
                            >
                                <NJIcon
                                    className='analysis-panel-info-icon'
                                    name="info"
                                    variant="information"
                                    size="sm"
                                />
                            </NJTooltip>

                        </div>
                    </Flex>

                </div>

                <hr className='analysis-panel-hr' />

                <div className='analysis-panel-opinion'>
                    What do you think about this Job Ad?
                </div>
                <Flex justify='flex-start' align="center" gap={12} >
                    <NJButton
                        className='analysis-opinion-button'
                        label="Well done!"
                        icon="thumb_up"
                        variant="primary" emphasis="minimal" size="small"
                        disabled={false}
                        onClick={(e) => { handleFeedbackButton(true) }}
                    />
                    <NJButton
                        className='analysis-opinion-button'
                        label="App can be improved"
                        icon="thumb_down"
                        variant="primary" emphasis="minimal" size="small"
                        disabled={false}
                        onClick={(e) => { handleFeedbackButton(false) }}
                    />
                </Flex>
            </div>
        </div>
    )
}

export default AnalysisPanel;